/**
 * HyreDocs Logo - Custom SVG logo component
 * Document with checkmark icon in brand gradient
 */
export function HyreDocsIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Document body */}
      <path 
        d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6Z" 
        fill="white" 
        fillOpacity="0.9"
      />
      {/* Document fold */}
      <path 
        d="M14 2L20 8H15C14.45 8 14 7.55 14 7V2Z" 
        fill="white" 
        fillOpacity="0.6"
      />
      {/* Checkmark */}
      <path 
        d="M9 13L11.5 15.5L16 10" 
        stroke="white" 
        strokeWidth="2.2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function HyreDocsLogo({ size = "md", showText = true }) {
  const sizes = {
    sm: { box: "w-8 h-8", icon: "w-4 h-4", text: "text-lg" },
    md: { box: "w-10 h-10", icon: "w-5 h-5", text: "text-xl" },
    lg: { box: "w-12 h-12", icon: "w-6 h-6", text: "text-2xl" },
  };
  
  const s = sizes[size] || sizes.md;
  
  return (
    <div className="flex items-center gap-3">
      <div className={`${s.box} rounded-xl bg-gradient-to-br from-[#f97316] to-[#f59e0b] flex items-center justify-center shadow-lg shadow-orange-500/30`}>
        <HyreDocsIcon className={s.icon} />
      </div>
      {showText && (
        <span className={`font-heading font-bold ${s.text}`}>HyreDocs</span>
      )}
    </div>
  );
}
